import { render, staticRenderFns } from "./FastReceive.vue?vue&type=template&id=1686716d&scoped=true"
import script from "./FastReceive.vue?vue&type=script&lang=js"
export * from "./FastReceive.vue?vue&type=script&lang=js"
import style0 from "./FastReceive.vue?vue&type=style&index=0&id=1686716d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686716d",
  null
  
)

export default component.exports